<template>
  <HeroBackground :slides="program.slides">
    <Container tag="section" class="hero">
      <div class="hero__info">
        <Title tag="h1">{{ program.title }}</Title>
        <p>
          {{ program.description }}
        </p>
        <div class="hero__buttons">
          <Button tag="router-link" theme="primary" to="/acerca-de"
            >Conoce más</Button
          >
          <!-- <Button theme="primary" tag="a" href="https://www.igp.gob.pe/convocatorias/" target="_blank">Convocatorias</Button> -->
        </div>
      </div>
      <div class="hero__media"></div>
    </Container>
  </HeroBackground>
</template>
<script>
import HeroBackground from "@/components/home/HeroBackground";

import Container from "@/components/ui/objects/Container";
import Title from "@/components/ui/atoms/Title";
import Button from "@/components/ui/atoms/Button";

export default {
  name: "Hero",
  components: {
    HeroBackground,
    Container,
    Title,
    Button
  },
  props: {
    program: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.swiper-container {
  background-color: yellow;
  height: 100%;
  .swiper-slide {
    background-color: tomato;
  }
}
.hero {
  &__info {
    padding: variables.$spacing-l 0;
  }
}
h1 {
  font-size: variables.$fs-title-l;
}
@media (min-width: 768px) {
  .hero {
    display: grid;
    grid-gap: variables.$spacing-xl;
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
